import { Box } from '@cmpsr/components';
import Marquee from 'react-fast-marquee';
import { SocialProofMini } from '.';

// Sample data for different proof people
const proofPeople = [
  { name: 'Alex R.', imageSrc: '/images/social-proof/mini-proof-people/alex.jpg', percentage: 45.2 },
  { name: 'Amir H.', imageSrc: '/images/social-proof/mini-proof-people/amir.jpg', percentage: 42.8 },
  { name: 'Caitlin M.', imageSrc: '/images/social-proof/mini-proof-people/caitlin.jpg', percentage: 39.6 },
  { name: 'Clara W.', imageSrc: '/images/social-proof/mini-proof-people/clara.jpg', percentage: 44.3 },
  { name: 'Ginger P.', imageSrc: '/images/social-proof/mini-proof-people/ginger.jpg', percentage: 41.4 },
  { name: 'Isaac J.', imageSrc: '/images/social-proof/mini-proof-people/isaac.jpg', percentage: 48.9 },
  { name: 'Leo D.', imageSrc: '/images/social-proof/mini-proof-people/leo.jpg', percentage: 52.1 },
  { name: 'Malik S.', imageSrc: '/images/social-proof/mini-proof-people/malik.jpg', percentage: 47.7 },
];

interface SocialProofMarqueeProps {
  direction?: 'left' | 'right';
  speed?: number;
  backgroundColor?: string;
}

export const SocialProofMarquee: React.FC<SocialProofMarqueeProps> = ({
  direction = 'left',
  speed = 40,
  backgroundColor,
}) => {
  const containerProps = backgroundColor ? { backgroundColor, padding: 'spacer-6' } : {};

  return (
    <Box maxWidth="100%" {...containerProps}>
      <Marquee
        speed={speed}
        gradient={false}
        direction={direction}
        autoFill={true}
        style={{ boxShadow: '0px 4px 44px 0px rgba(0, 0, 0, 0.15)' }}
      >
        {proofPeople.map((proof, index) => (
          <Box key={index} padding="0 12px" boxShadow="0px 4px 44px 0px rgba(0, 0, 0, 0.15)">
            <SocialProofMini
              name={proof.name}
              imageSrc={proof.imageSrc}
              percentage={proof.percentage}
              graphKey={index}
            />
          </Box>
        ))}
      </Marquee>
    </Box>
  );
};

export default SocialProofMarquee;
